export function isContainsInSVG(element: HTMLElement): boolean {
  let node = element.parentNode;
  while (node != null) {
    if (node.nodeName === 'svg') {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}

export function getBrowserScalePercentage(): number {
  return Math.round(window.devicePixelRatio * 100);
}

export function convertToTeamsClientCoordinates(value: number): number {
  return (value / 100) * getBrowserScalePercentage();
}

export function convertFromTeamsClientCoordinates(value: number): number {
  return (value / getBrowserScalePercentage()) * 100;
}

export function isOnlyInBrowserOpenedLinks(link: string): boolean {
  const hosts = ['apps.powerapps.com', 'dynamics.com'];
  return URL.canParse(link) && hosts.includes(new URL(link).host);
}
